// extracted by mini-css-extract-plugin
export default {"ErrorLabel":"ListError_ErrorLabel__ars8q"};